// extracted by mini-css-extract-plugin
module.exports = {"mecha":"index-mecha-rQqgz","btnDetail":"index-btnDetail-1dQk-","active":"index-active-30-mt"};